import Vue, { computed } from "vue";
import Vuetify, {
  VAlert,
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAutocomplete,
  VAvatar,
  VBadge,
  VBottomSheet,
  VBtn,
  VCalendar,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VCarousel,
  VCarouselItem,
  VCheckbox,
  VChip,
  VCol,
  VColorPicker,
  VCombobox,
  VContainer,
  VDatePicker,
  VDialog,
  VDivider,
  VExpandTransition,
  VExpandXTransition,
  VExpansionPanel,
  VExpansionPanelContent,
  VExpansionPanelHeader,
  VExpansionPanels,
  VFileInput,
  VFlex,
  VFooter,
  VForm,
  VIcon,
  VImg,
  VItem,
  VItemGroup,
  VLabel,
  VLayout,
  VList,
  VListGroup,
  VListItem,
  VListItemAction,
  VListItemContent,
  VListItemGroup,
  VListItemIcon,
  VListItemSubtitle,
  VListItemTitle,
  VMain,
  VMenu,
  VNavigationDrawer,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VRow,
  VScrollXTransition,
  VSelect,
  VSheet,
  VSkeletonLoader,
  VSlider,
  VSlideXTransition,
  VSlideYTransition,
  VSnackbar,
  VSpacer,
  VSpeedDial,
  VStepper,
  VStepperHeader,
  VStepperContent,
  VStepperItems,
  VStepperStep,
  VSwitch,
  VTab,
  VTabs,
  VTabsSlider,
  VTextarea,
  VTextField,
  VTimePicker,
  VTimeline,
  VTimelineItem,
  VToolbar,
  VToolbarTitle,
  VTooltip,
  VWindow,
  VWindowItem,
  VVirtualScroll,
} from "vuetify/lib";
import { Intersect } from "vuetify/lib/directives";

// Register our common components globally
import "./registerComponents";
import appStore from "@/store/modules/appStore";

Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VAutocomplete,
    VAvatar,
    VBadge,
    VBottomSheet,
    VBtn,
    VCalendar,
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VCarousel,
    VCarouselItem,
    VCheckbox,
    VChip,
    VCol,
    VColorPicker,
    VCombobox,
    VContainer,
    VDatePicker,
    VDialog,
    VDivider,
    VExpandTransition,
    VExpandXTransition,
    VExpansionPanel,
    VExpansionPanelContent,
    VExpansionPanelHeader,
    VExpansionPanels,
    VFileInput,
    VFlex,
    VForm,
    VFooter,
    VIcon,
    VImg,
    VItem,
    VItemGroup,
    VLabel,
    VLayout,
    VList,
    VListGroup,
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemGroup,
    VListItemIcon,
    VListItemSubtitle,
    VListItemTitle,
    VMain,
    VMenu,
    VNavigationDrawer,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VRow,
    VScrollXTransition,
    VSelect,
    VSpeedDial,
    VSheet,
    VSkeletonLoader,
    VSlider,
    VSlideXTransition,
    VSlideYTransition,
    VSnackbar,
    VSpacer,
    VSwitch,
    VStepper,
    VStepperHeader,
    VStepperContent,
    VStepperItems,
    VStepperStep,
    VTab,
    VTabs,
    VTabsSlider,
    VTextField,
    VTextarea,
    VTimePicker,
    VTimeline,
    VTimelineItem,
    VToolbar,
    VToolbarTitle,
    VTooltip,
    VWindow,
    VWindowItem,
    VVirtualScroll,
  },
  directives: {
    Intersect,
  },
});

export const customColoursLight = {
  primary: "#002E5D",

  // Custom
  brand01: "#002E5D",
  brand01Hover: "#003F7F",
  brand01Clicked: "#002E5D",
  brand02: "#5596e6",
  brand02Hover: "#73a8ea",
  brand02Clicked: "#3784e2",
  brand03: "#ffbb32",
  brand03Hover: "#ffc654",
  brand03Clicked: "#ffb010",
  brand04: "#B27700",
  brand04Hover: "#d48e00",
  brand04Clicked: "#906000",

  background01: "#fff",
  background02: "#F4F7FB",
  background03: "#FBF8ED",
  background04: "#FAFAF9",

  borders: "#E2E2E2",

  text01: "#505457",
  text02: "#73777A",
  text03: "#AAAAAA",
  text04: "#FFF",
  linkText: "#195AAA",

  error: "#C5352C",
  warning: "#FFB800",
  info: "#003A56",
  success: "#006E00",

  errorLight: "#FFB6B2",
  warningLight: "#FFFAE9",
  infoLight: "#87C1DD",
  successLight: "#B9DFC9",

  errorMedium: "#C5352C",
  warningMedium: "#FFB800",
  infoMedium: "#003A56",
  successMedium: "#006E00",

  errorPastel: "#C5352C",
  warningPastel: "#F8E8C8",
  infoPastel: "#003A56",
  successPastel: "#DCEDDC",

  switch: "#27AE60",

  darkBlue: "#3b69a1",
  lightBlue: "#77d2ff",
  mediumBlue: "#5596E6",

  lightGrey: "#e8e8e8",
  footer: "#fff",
  primaryChip: "#002E5D",
  errorChip: "#C5352C",
  greyChip: "#AAAAAA",
  primaryButton: "#002E5D",
};

export const customColoursDark = {
  primary: "#bdd8f3",

  // Custom
  brand01: "#bdd8f3",
  brand01Hover: "#E6EBF1",
  brand01Clicked: "#4273A3",
  brand02: "#2d9dd9",
  brand02Hover: "#E5F2FC",
  brand02Clicked: "#4EA7F6",
  brand03: "#FFE48D",
  brand03Hover: "#FFF9E4",
  brand03Clicked: "#FFD044",
  brand04: "#B27700",
  brand04Hover: "#d48e00",
  brand04Clicked: "#906000",

  background01: "#262626",
  background02: "#1A1A1A",
  background03: "#333333",
  background04: "#353535",

  borders: "#73777A",

  text01: "#FFFFFF",
  text02: "#E8E8E8",
  text03: "#D0D0D0",
  text04: "#505457",
  linkText: "#C1DEF9",

  error: "#e0938f",
  warning: "#eaac38",
  info: "#2d9dd9",
  success: "#308801",

  errorLight: "#FFB6B2",
  warningLight: "#FFFAE9",
  infoLight: "#87C1DD",
  successLight: "#B9DFC9",

  errorMedium: "#9e2020",
  warningMedium: "#FFD466",
  infoMedium: "#8BACB1",
  successMedium: "#71AD71",

  errorPastel: "#C5352C",
  warningPastel: "#F8E8C8",
  infoPastel: "#003A56",
  successPastel: "#DCEDDC",

  switch: "#71AD71",

  darkBlue: "#3b69a1",
  lightBlue: "#77d2ff",
  mediumBlue: "#5596E6",

  lightGrey: "#e8e8e8",
  footer: "#262626",
  primaryChip: "#2d9dd9",
  errorChip: "#9e2020",
  greyChip: "#505457",
  primaryButton: "#2d9dd9",
};

const vuetify = new Vuetify({
  icons: {
    iconfont: "md",
    values: {
      // Register custom icons into vuetify
      accept: "custom-icon accept",
      acceptDark: "custom-icon accept-dark",
      cancel: "custom-icon cancel",
      cancelDark: "custom-icon cancel-dark",
      phone: "custom-icon phone",
      phoneDark: "custom-icon phone-dark",
      customise: "custom-icon customise",
      customiseDark: "custom-icon customise-dark",
      van: "custom-icon van",
    },
  },
  theme: {
    themes: {
      light: {
        ...customColoursLight,
      },
      dark: {
        ...customColoursDark,
      },
    },
  },
});

export const useThemedIcons = () => {
  const icons = computed(() => {
    const isDark = appStore.state.theme === "dark";

    return {
      accept: isDark ? "acceptDark" : "accept",
      customise: isDark ? "customiseDark" : "customise",
      cancel: isDark ? "cancelDark" : "cancel",
      phone: isDark ? "phoneDark" : "phone",
    };
  });

  return {
    icons,
  };
};

// Expose $vuetify as vuetify.framework as this is what we naturally work with
export const useVuetify = () => ({
  $vuetify: vuetify.framework,
});

export default vuetify;
